"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var userAgent_1 = require("./userAgent");

var unlockOnPortrait_1 = require("./unlockOnPortrait");

var moz = {
  fullscreenElement: 'mozFullScreenElement',
  exitFullscreen: 'mozCancelFullScreen',
  requestFullscreen: 'mozRequestFullScreen'
};
var webkit = {
  fullscreenElement: 'webkitFullscreenElement',
  exitFullscreen: 'webkitExitFullscreen',
  requestFullscreen: 'webkitRequestFullscreen'
};
var ms = {
  fullscreenElement: 'msFullscreenElement',
  exitFullscreen: 'msExitFullscreen',
  requestFullscreen: 'msRequestFullscreen'
};
var iOs = {
  fullscreenElement: 'webkitCurrentFullScreenElement',
  requestFullscreen: 'webkitEnterFullscreen',
  exitFullscreen: 'webkitCancelFullScreen'
};
var doc = typeof document !== 'undefined' ? document : {};
var win = typeof window !== 'undefined' ? window : undefined;
var vendor = moz.fullscreenElement in doc && moz || webkit.fullscreenElement in doc && webkit || ms.fullscreenElement in doc && ms || userAgent_1.isIos(win) && iOs;
/**
 * Following Google guidelines:
 * https://developers.google.com/web/fundamentals/media/mobile-web-video-playback#lock_screen_in_landscape_on_button_click
 */

var lockScreenInLandscape = function lockScreenInLandscape() {
  if (!screen || !('orientation' in screen) || typeof matchMedia === 'undefined') {
    return;
  } // Let's force landscape mode only if device is in portrait mode and can be held in one hand.


  if (matchMedia('(orientation: portrait) and (max-device-width: 768px)').matches) {
    screen.orientation.lock('landscape').then(function () {
      unlockOnPortrait_1.default();
    });
  }
};

exports.requestFullscreen = function (element) {
  return vendor && element[vendor.requestFullscreen]();
};

exports.exitFullscreen = function () {
  return vendor && document[vendor.exitFullscreen]();
};

exports.getActiveFullscreenElement = function () {
  return vendor && document[vendor.fullscreenElement];
};

exports.toggleFullscreen = function (fullscreenElement) {
  if (!fullscreenElement) {
    return;
  }

  if (exports.getActiveFullscreenElement() !== fullscreenElement) {
    exports.requestFullscreen(fullscreenElement);
    lockScreenInLandscape();
  } else {
    exports.exitFullscreen();
  }
};